import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';

const StatTableView = ({ tableData, selectedAction, setSelectedAction, includedRowSpan, excludedRowSpan }) => {
  return (
    <TableContainer 
      component={Paper} 
      variant="outlined" 
      sx={{ 
        borderRadius: 0, 
        border: '1px solid #A2C4E4', 
        overflowX: 'auto', 
        width: '100%',
        boxShadow: 'none'
      }}
    >
      <Table 
        size="small" 
        sx={{ 
          minWidth: 900, 
          tableLayout: 'fixed', 
          width: '100%',
          '& th': { fontSize: '13px', p: '6px 8px', border: '1px solid #A2C4E4', textAlign: 'center' },
          '& td': { border: '1px solid #A2C4E4', textAlign: 'center', p: '6px 8px', fontSize: '13px', color: '#000000' } 
        }}
      >
        <colgroup>
          <col style={{ width: '90px' }} />
          <col style={{ width: '160px' }} />
          {tableData.teamMembers.map((m) => (
            <col key={m.id} style={{ width: 'auto', minWidth: '70px' }} />
          ))}
          <col style={{ width: '95px' }} />
          <col style={{ width: '110px' }} />
        </colgroup>

        <TableHead sx={{ backgroundColor: '#D6E6F5' }}>
          <TableRow>
            <TableCell colSpan={2} sx={{ fontWeight: '700', color: '#000', textAlign: 'center' }}>구분</TableCell>
            {tableData.teamMembers.map(m => (
              <TableCell key={m.id} sx={{ fontWeight: '700', color: '#000', textAlign: 'center' }}>
                {m.name}
              </TableCell>
            ))}
            <TableCell sx={{ fontWeight: '700', color: '#000', textAlign: 'center' }}>팀 평균</TableCell>
            <TableCell sx={{ fontWeight: '700', color: '#000', textAlign: 'center' }}>부문별 가동률</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          
          {tableData.tableRows.length > 0 ? (
            tableData.tableRows.map((row, idx) => (
              <TableRow 
                key={row.name} 
                hover
                selected={selectedAction === row.name}
                onClick={() => setSelectedAction(row.name)}
                sx={{ cursor: 'pointer', '&.Mui-selected': { backgroundColor: 'rgba(214, 230, 245, 0.4)' } }}
              >
                {idx === 0 && (
                  <TableCell rowSpan={includedRowSpan} sx={{ fontWeight: '500', backgroundColor: '#FFFFFF' }}>
                    가동률<br />포함
                  </TableCell>
                )}
                <TableCell sx={{ textAlign: 'left', pl: 4, fontWeight: '500' }}>
                  {row.name}
                </TableCell>
                {row.memberValues.map((val, mIdx) => (
                  <TableCell key={mIdx}>{val}</TableCell>
                ))}
                <TableCell>{row.totalDays.toFixed(1)}</TableCell>
                <TableCell sx={{ fontWeight: '500' }}>{tableData.calcRate(row.totalDays)}</TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell sx={{ fontWeight: '500', backgroundColor: '#FFFFFF' }}>가동률 포함</TableCell>
              <TableCell colSpan={tableData.teamMembers.length + 3} sx={{ color: 'text.disabled' }}>데이터가 없습니다.</TableCell>
            </TableRow>
          )}

          <TableRow sx={{ backgroundColor: '#EAEAEA' }}>
            <TableCell colSpan={2} sx={{ fontWeight: '700', textAlign: 'center' }}>소계 (A)</TableCell>
            {tableData.includedMemberTotals.map((tot, mIdx) => (
              <TableCell key={mIdx} sx={{ fontWeight: '500' }}>{tot}</TableCell>
            ))}
            <TableCell sx={{ fontWeight: '500' }}>{tableData.totalIncludedDays.toFixed(1)}</TableCell>
            <TableCell sx={{ fontWeight: '500' }}>{tableData.calcRate(tableData.totalIncludedDays)}</TableCell>
          </TableRow>

          {tableData.excludedRows.length > 0 ? (
            tableData.excludedRows.map((row, idx) => (
              <TableRow 
                key={row.name} 
                hover
                selected={selectedAction === row.name}
                onClick={() => setSelectedAction(row.name)}
                sx={{ cursor: 'pointer', '&.Mui-selected': { backgroundColor: 'rgba(214, 230, 245, 0.4)' } }}
              >
                {idx === 0 && (
                  <TableCell rowSpan={excludedRowSpan + 1} sx={{ fontWeight: '500', backgroundColor: '#FFFFFF' }}>
                    가동률<br />제외
                  </TableCell>
                )}
                <TableCell sx={{ textAlign: 'left', pl: 4, fontWeight: '500' }}>
                  {row.name}
                </TableCell>
                {row.memberValues.map((val, mIdx) => (
                  <TableCell key={mIdx}>{val}</TableCell>
                ))}
                <TableCell>{row.totalDays.toFixed(1)}</TableCell>
                <TableCell sx={{ fontWeight: '500' }}>{tableData.calcRate(row.totalDays)}</TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell sx={{ fontWeight: '500', backgroundColor: '#FFFFFF' }}>가동률 제외</TableCell>
              <TableCell colSpan={tableData.teamMembers.length + 3} sx={{ color: 'text.disabled' }}>데이터가 없습니다.</TableCell>
            </TableRow>
          )}

          <TableRow sx={{ backgroundColor: '#EAEAEA' }}>
            <TableCell sx={{ fontWeight: '700', textAlign: 'center' }}>소계</TableCell>
            {tableData.excludedMemberTotals.map((val, mIdx) => (
              <TableCell key={mIdx} sx={{ fontWeight: '500' }}>{val}</TableCell>
            ))}
            <TableCell sx={{ fontWeight: '500' }}>{tableData.totalExcludedDays.toFixed(1)}</TableCell>
            <TableCell sx={{ fontWeight: '500' }}>{tableData.calcRate(tableData.totalExcludedDays)}</TableCell>
          </TableRow>

          <TableRow sx={{ backgroundColor: '#D5E6F5' }}>
            <TableCell colSpan={2} sx={{ fontWeight: '700', fontSize: '14px' }}>합 계</TableCell>
            {tableData.sumMemberTotals.map((tot, mIdx) => (
              <TableCell key={mIdx} sx={{ fontWeight: '700', fontSize: '14px' }}>{tot}</TableCell>
            ))}
            <TableCell sx={{ fontWeight: '700', fontSize: '14px' }}>{tableData.totalSumDays.toFixed(1)}</TableCell>
            <TableCell sx={{ fontWeight: '700', fontSize: '14px' }}>100%</TableCell>
          </TableRow>

          <TableRow sx={{ backgroundColor: '#F2F7FC' }}>
            <TableCell colSpan={2} sx={{ fontWeight: '500', textAlign: 'left', pl: 1 }}>
              실가동률 = A ÷ (기준공수 - 휴가)
            </TableCell>
            {tableData.teamMembers.map((m, idx) => {
              const currentRateStr = tableData.memberRealRates?.[idx] || '0%';
              const currentRateNum = parseFloat(currentRateStr);
              const isLowRate = currentRateNum < 65; 
              
              return (
                <TableCell key={idx} sx={{ fontWeight: '700', color: isLowRate ? '#D32F2F' : '#000000' }}>
                  {currentRateStr}
                </TableCell>
              );
            })}
            <TableCell sx={{ fontWeight: '700' }}>{tableData.realWorkingRate}</TableCell>
            <TableCell sx={{ color: '#000000' }}>-</TableCell>
          </TableRow>

        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default StatTableView;
